var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderBoardArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 8,
    viewBox: "0 0 64 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3536 4.03556C63.5488 3.8403 63.5488 3.52372 63.3536 3.32845L60.1716 0.146473C59.9763 -0.0487893 59.6597 -0.0487893 59.4645 0.146473C59.2692 0.341735 59.2692 0.658318 59.4645 0.85358L62.2929 3.68201L59.4645 6.51043C59.2692 6.7057 59.2692 7.02228 59.4645 7.21754C59.6597 7.4128 59.9763 7.4128 60.1716 7.21754L63.3536 4.03556ZM0 3.68201V4.18201H63V3.68201V3.18201H0V3.68201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderBoardArrow);
export default __webpack_public_path__ + "static/media/LeaderBoardArrow.f547038b47f8e191c44b3eee01485b6e.svg";
export { ForwardRef as ReactComponent };